import { useContext } from 'react';
import ResourceContext from './ResourceContext';

export default function useResourceContext() {
  return useContext(ResourceContext);
}
